export default __webpack_public_path__ + "images/0x81be2acb2e9291db6400f9f6a4d0f35f24de2e77.png";